import React from "react";

export const PersonalCart = ({ currentUser, handleSignOut }) => {
  return (
    <div className="border bg-white w-48 h-60 top-14 absolute right-0 flex justify-center p-5 rounded-lg hover:shadow-lg flex-col items-center">
      <p className="text-xl mb-3 text-green-600">Welcome</p>
      <h3 className="text-2xl font-bold mb-5">{currentUser.fullname}</h3>
      <button
        onClick={handleSignOut}
        className="w-full flex justify-center items-center h-12 px-7 active:bg-green-600 rounded-3xl border-none bg-green-600 text-white text-lg font-semibold outline-none focus:outline-none"
      >
        Sign Out
      </button>
    </div>
  );
};
